require("./uploadedDocumentRow.scss");

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash/object/get');
const classnames = require('classnames');

//@helper
const { FormattedText, formatText } = require('core/i18n').i18n;

//@commons
const { OKIconButton } = require('commonsComponents/OKIconButton');
const { OKTextArea } = require('commonsComponents/OKTextArea');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('components/commons/OKModal/OKModal');

//@constants
const {
    FILE_DISCRIPTION_CHARS_LIMIT
} = require('constants/accountDirectDebit');

class UploadedDocumentRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isImgPreviewerOpen: false,
            fileData:'',
            fileName: '',
            index: ''
        };
        this.handleImgPreviewerClick = this.handleImgPreviewerClick.bind(this);
    }

    handleImgPreviewerClick(fileData, fileName, index) {
        this.setState({
            isImgPreviewerOpen: !this.state.isImgPreviewerOpen,
            fileData,
            fileName,
            index
        });
    }

    render() {
        const {
            filesAttached,
            removeFile,
            setDescription,
            hideDescription,
            uploadDocumentLabel
        } = this.props;
        let content;
        if(filesAttached.size > 0){
            content = filesAttached.map((fileData, index) => {
                const file = fileData.getIn(['data','file']);
                const fileType = get(file,'type','').split('/')[1];
                let previewContent;
                if(fileType !== 'pdf') {
                    previewContent = (
                        <div className="uploaded-document-row__container-preview-img">
                            <OKButton
                                modifier="link-ghost"
                                onClick={(event) => {
                                    this.handleImgPreviewerClick(fileData.getIn(['data', 'base64']), fileData.get('name'), index, event);
                                }}
                            >
                                <img
                                    alt={formatText(uploadDocumentLabel, [index+1])}
                                    className="uploaded-document-row__preview-img"
                                    src={fileData.getIn(['data','base64'])}
                                />
                            </OKButton>
                        </div>
                    );
                }else {
                    previewContent = (
                        <div className="uploaded-document-row__preview  uploaded-document-row__preview--pdf-container icon-pdf"></div>
                    );
                }
                const descriptionElement = !hideDescription && (
                    <div className="uploaded-document-row__description pull-left">
                        <OKTextArea
                            value={fileData.get('description')}
                            onChange={(event) => {
                                setDescription(index, event.target.value);
                            }}
                            maxLength={FILE_DISCRIPTION_CHARS_LIMIT}
                            customClass="uploaded-document-row__text-area"
                        />
                    </div>
                );
                const deleteClassNames = classnames('uploaded-document-row__delete-button', {
                    'pull-left': !hideDescription,
                    'pull-right': hideDescription
                });

                return(
                    <section key={index} className="uploaded-document-row">
                        <div className="uploaded-document-row__preview pull-left">
                            {previewContent}
                        </div>
                        <div className="uploaded-document-row__name pull-left">
                            <p className="uploaded-document-row__label">
                                <FormattedText value={uploadDocumentLabel} injectedStrings={[index+1]}/>
                            </p>
                            <p className="uploaded-document-row__file-name">{fileData.get('name')}</p>
                        </div>
                        {descriptionElement}
                        <div className={deleteClassNames}>
                            <OKIconButton icon="icon-eliminar" onClick={() => {
                                removeFile(index);
                            }}/>
                        </div>
                    </section>
                );
            });
        }
        const contentModal = (
            <div className="uploaded-document-row__modal-preview">
                <img
                    alt={formatText(uploadDocumentLabel, [this.state.index+1])}
                    className="uploaded-document-row__modal-preview-img"
                    src={this.state.fileData}
                />
            </div>
        );

        return(
            <React.Fragment>
                <OKModal
                    content={contentModal}
                    contentOverflow="auto"
                    isOpen={this.state.isImgPreviewerOpen}
                    onCloseCallback={this.handleImgPreviewerClick}
                    title={this.state.fileName}
                />
                {content}
            </React.Fragment>
        );
    }
}

UploadedDocumentRow.propTypes = {
    filesAttached: PropTypes.object,
    hideDescription: PropTypes.bool,
    removeFile: PropTypes.func.isRequired,
    setDescription: PropTypes.func.isRequired,
    uploadDocumentLabel: PropTypes.string
}

UploadedDocumentRow.defaultProps = {
    setDescription: () => {}
}

module.exports = UploadedDocumentRow;
